<div class="PGSupplierDeleteConfirm">
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-supplier-delete-confirm.title' | locTranslate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <p class="mb-2">{{ 'pg-supplier-delete-confirm.message' | locTranslate:'count':totalCount }}</p>
        @if (experienceLabels.length) {
            <div class="mb-2">
                @for (label of experienceLabels; track $index) {
                    <div>{{ label }}</div>
                }
            </div>
        }
        <p class="mb-0">{{ 'pg-supplier-delete-confirm.confirm' | locTranslate }}</p>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modal.dismiss()">
            {{ 'pg-supplier-delete-confirm.button-cancel' | locTranslate }}
        </button>
        <button class="btn btn-danger" (click)="modal.close(true)">
            {{ 'pg-supplier-delete-confirm.button-confirm' | locTranslate }}
        </button>
    </div>
</div>
